import script from "./AppTitle.vue?vue&type=script&lang=ts"
export * from "./AppTitle.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__